import { call, put, take, takeEvery } from 'redux-saga/effects'
import { api } from '../services/api'
import { publishTracking } from '../services/tracking'
import {
  PROFILE_FETCH_PENDING,
  PROFILE_FETCH_SUCCESS,
  PROFILE_FETCH_FAIL,
  PROFILE_UPDATE_PENDING,
  PROFILE_UPDATE_SUCCESS,
  PROFILE_UPDATE_FAIL,
  PHOTO_UPDATE_PENDING,
  PHOTO_UPDATE_SUCCESS,
  PHOTO_UPDATE_FAIL,
  PASSWORD_UPDATE_PENDING,
  PASSWORD_UPDATE_SUCCESS,
  PASSWORD_UPDATE_FAIL,
} from '../actions/index'

function* fetchProfile() {
  try {
    const profile = yield call(api.accountInfo)
    yield put({ type: PROFILE_FETCH_SUCCESS, payload: profile })
  } catch (e) {
    yield put({ type: PROFILE_FETCH_FAIL, payload: e.message })
  }
}

function* updateProfile(action) {
  try {
    const profile = yield call(api.updateAccountInfo, action.payload)
    yield put({ type: PROFILE_UPDATE_SUCCESS, payload: profile })
  } catch (e) {
    yield put({ type: PROFILE_UPDATE_FAIL, payload: e.message })
  }
}

function* updatePhoto(action) {
  try {
    const payload = yield call(api.updatePhoto, action.payload)
    yield put({ type: PHOTO_UPDATE_SUCCESS, payload: payload })
  } catch (e) {
    yield put({ type: PHOTO_UPDATE_FAIL, payload: e.message })
  }
}

function* updatePassword(action) {
  try {
    const profile = yield call(api.updateAccountInfo, action.payload)
    yield put({ type: PASSWORD_UPDATE_SUCCESS, payload: profile })

    publishTracking({
      userAction: 'forgot pass successful change',
      event: 'event150',
    })
  } catch (e) {
    let message = e.message
    if (e.response && e.response.data && e.response.data.errors) {
      message = e.response.data.errors[0]
    }
    yield put({ type: PASSWORD_UPDATE_FAIL, payload: message })
  }
}

export function* profileFetch() {
  yield takeEvery(PROFILE_FETCH_PENDING, fetchProfile)
}

export function* profileUpdate() {
  yield takeEvery(PROFILE_UPDATE_PENDING, updateProfile)
}

export function* photoUpdate() {
  yield takeEvery(PHOTO_UPDATE_PENDING, updatePhoto)
}

export function* passwordUpdate() {
  yield takeEvery(PASSWORD_UPDATE_PENDING, updatePassword)
}



// WEBPACK FOOTER //
// ./src/sagas/profile.js